import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router/index'
// import * as Cookies from 'js-cookie'
import createPersistedState from 'vuex-persistedstate'
import { _ } from 'vue-underscore'
import firebase from 'firebase/app'
require('firebase/auth')

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    profissional_result: null,
    pendingScheduling: false,
    popupCheck: false,
    rescheduling_data: {},
    scheduling_data: {
      searchParams: {},
      selectedProfessional: {},
      sessionPackage: {},
      clientInfo: {},
      addressInfo: {},
      cupomInfo: {}
    },
    adminScheduling: {},
    adminAuthentication: {
      token: null,
      id: null,
      email: null,
      nome: null
    },
    idToken: null,
    idlogin: null,
    firebaseUser: null,
    firebaseCredential: null,
    login: null,
    tipo_user: null,
    account_type: null,
    perfil: null,
    drawer: false,
    exp: null,
    notFailed: true,
    logged: false,
    aprovado: null,
    loading: false,
    id: null,
    unreadMessages: 0,
    intervalID: null
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  plugins: [
    createPersistedState({
      paths: [
        'idToken',
        'idlogin',
        'tipo_user',
        'account_type',
        'perfil',
        'login',
        'exp',
        'status',
        'logged',
        'aprovado',
        'profissional_result',
        'firebaseUser',
        'firebaseCredential'
      ]
    })
  ],
  getters: {
    getDrawer: state => {
      return state.drawer
    },
    getidToken: state => {
      return state.idToken
    },
    isAuthenticated(state) {
      return state.idToken !== null
    },
    isApproved(state) {
      return state.aprovado
    },
    getFirebaseAuth() {
      return firebase.auth
    },
    getFirebaseUser(state) {
      return state.firebaseUser
    },
    getFirebaseUserID(state) {
      return state.firebaseUser ? state.firebaseUser.uid : null
    },
    getFirebaseCredential(state) {
      return state.firebaseCredential
    },
    getPendingScheduling(state) {
      return state.pendingScheduling
    },
    getUserLogin: state => {
      return state.login
    },
    getUserID: state => {
      return state.idlogin
    },
    getUserType: state => {
      return state.tipo_user
    },
    getAccountType: state => {
      return state.account_type
    },
    getProfissionalResult: state => {
      return state.profissional_result
    },
    getSchedulingData: state => {
      return state.scheduling_data
    },
    getReschedulingData: state => {
      return state.rescheduling_data
    },
    getSearchParams: state => {
      return state.scheduling_data.searchParams
    },
    getPerfil: state => {
      return state.perfil
    },
    getPerfilID: state => {
      return state.perfil && state.perfil.id ? state.perfil.id : null
    },
    getAdminAuthentication: state => {
      return state.adminAuthentication
    },
    getAdminScheduling: state => {
      return state.adminScheduling
    },
    isPerfilSelected: state => {
      return state.perfil && state.perfil.id != null
    },
    getSession: state => {
      return state.session
    },
    getSessionFinal: state => {
      return state.sessionFinal
    },
    getDaySessionIndex: state => {
      return state.daySessionIndex
    },
    getIntervalID: state => {
      return state.intervalID
    },
    getMessageCount: state => {
      return state.unreadMessages
    },
    getPopupChecker: state => {
      return state.popupCheck
    }
  },
  mutations: {
    authUser(state, userData) {
      state.idToken = userData.token
      state.idlogin = userData.idlogin
      state.user_id = userData.user_id
      state.tipo_user = userData.tipo_user
      state.account_type = userData.tipo_user
      state.login = userData.login
      state.aprovado = userData.aprovado
      state.exp = userData.exp
    },

    authAdmin(state, adminData) {
      state.adminAuthentication.token = adminData.token
      state.adminAuthentication.nome = adminData.nome
      state.adminAuthentication.email = adminData.email
      state.adminAuthentication.id = adminData.id
    },

    updateToken(state, token) {
      state.idToken = token
    },

    saveSessionAdress(state, sessionAdress) {
      state.adress = sessionAdress.adress
      state.number = sessionAdress.number
      state.neighborhood = sessionAdress.neighborhood
      state.district = sessionAdress.district
      state.zone = sessionAdress.zone
    },

    setUnreadMessages(state, value) {
      state.unreadMessages = value
    },
    clearAuthData(state) {
      state.idToken = null
      state.tipo_user = null
      state.userFirebaseId = null
      state.firebaseUser = null
      state.firebaseCredential = null
      state.perfil = null
    },
    clearAdminData(state) {
      state.adminAuthentication.token = null
      state.adminAuthentication.nome = null
      state.adminAuthentication.email = null
      state.adminAuthentication.id = null
    },
    clearReschedulingData(state) {
      state.rescheduling_data = {}
    },
    resetState(state) {
      console.log('Clearing State...')
      Object.assign(state, getDefaultState())
    },
    notFailed(state) {
      state.notFailed = false
      state.loading = false
    },
    notLogged(state) {
      state.logged = false
      state.loading = false
    },
    Logged(state) {
      state.logged = true
    },
    setUserType(state, type) {
      state.tipo_user = type
    },
    setPopupChecker(state, value) {
      state.popupCheck = value
    },
    saveProfissionalResult(state, result) {
      state.profissional_result = result
    },
    setAdminScheduling(state, userData) {
      Object.assign(state.adminScheduling, userData)
    },
    clearAdminScheduling(state) {
      state.adminScheduling = {}
    },
    saveSearchParams(state, params) {
      Object.assign(state.scheduling_data.searchParams, params)
    },
    saveSessions(state, params) {
      Object.assign(state.scheduling_data.sessionPackage, params)
    },
    saveSelectedProfessional(state, params) {
      Object.assign(state.scheduling_data.selectedProfessional, params)
    },
    saveClientInfo(state, params) {
      Object.assign(state.scheduling_data.clientInfo, params)
    },
    saveAddressInfo(state, params) {
      Object.assign(state.scheduling_data.addressInfo, params)
    },
    saveReschedulingData(state, params) {
      Object.assign(state.rescheduling_data, params)
    },
    saveCupomInfo(state, params) {
      state.scheduling_data.cupomInfo = { ...params }
    },
    clearCupomInfo(state) {
      state.scheduling_data.cupomInfo = {}
    },
    clearSchedulingData(state) {
      Object.assign(state.scheduling_data, {
        searchParams: {},
        selectedProfessional: {},
        sessionPackage: {},
        clientInfo: {},
        addressInfo: {},
        cupomInfo: {}
      })
    },
    savePerfilID(state, resultID) {
      state.id = resultID
    },
    setPerfil(state, perfil) {
      state.perfil = perfil
    },
    setPendingScheduling(state, value) {
      state.pendingScheduling = value
    },
    setSession(state, session) {
      state.session = session
    },
    setSessionFinal(state, sessionFinal) {
      state.sessionFinal = sessionFinal
    },
    setDaySessionIndex(state, daySessionIndex) {
      state.daySessionIndex = daySessionIndex
    },
    setIntervalID(state, value) {
      state.intervalID = value
    },
    setFirebaseUser(state, user) {
      state.firebaseUser = user
    },
    setFirebaseCredential(state, credential) {
      state.firebaseCredential = credential
    }
  },
  actions: {
    setMessageTimer({ dispatch, commit, getters }) {
      // Recupera o ultimo ID da store e limpa o interval:
      clearInterval(getters.getIntervalID)
      dispatch('fetchMessagesCounter')
      // Cria um novo intervalo e salva sua ID:
      let id = setInterval(() => {
        // console.log('Dispatching...');
        dispatch('fetchMessagesCounter')
      }, 120000)
      // Salva o ID na Store:
      commit('setIntervalID', id)
    },
    fetchMessagesCounter({ commit, dispatch, getters }) {
      if (
        !_.contains(
          [
            'login',
            'signin',
            'NovaConta',
            'contact',
            'contato',
            'contactCompany',
            'contatoEmpresa',
            'selecionarperfil',
            'perfilselect',
            'reset',
            'redefinir',
            'confirm',
            'registro',
            'register'
          ],
          router.currentRoute.name
        )
      ) {
        dispatch('checkUserStatus').then(user => {
          user.getIdToken(true).then(token => {
            axios
              .get(process.env.VUE_APP_ITS_API + 'get/count-messages.php', {
                params: {
                  token: token,
                  user_id: getters.getFirebaseUserID,
                  idperfil: getters.getPerfilID,
                  tipo_perfil: getters.getUserType,
                  sender: false,
                  viewed: 0
                }
              })
              .then(response => {
                // console.log(response);
                switch (response.data.status) {
                  case 200:
                    commit('setUnreadMessages', response.data.count)
                    break
                  default:
                    break
                }
              })
          })
        })
      }
    },
    setLogoutTimer({ commit }, exp) {
      setTimeout(() => {
        commit('clearAuthData')
      }, exp)
    },
    setAdminTimer({ commit }, exp) {
      setTimeout(() => {
        commit('clearAdminData')
      }, exp)
    },
    // eslint-disable-next-line
    passwordLogin({ commit, state }, payload) {
      firebase.auth().languageCode = 'pt-BR'
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signInWithEmailAndPassword(payload.email, payload.senha)
          .then(result => {
            resolve(result)
          })
          .catch(function(err) {
            // Handle Errors here.
            reject(err)
          })
      })
    },
    // eslint-disable-next-line
    socialLogin({ commit, state }, payload) {
      firebase.auth().languageCode = 'pt-BR'
      return new Promise((resolve, reject) => {
        let provider
        switch (payload.provider) {
          case 'Google':
            provider = new firebase.auth.GoogleAuthProvider()
            break
          case 'Facebook':
            provider = new firebase.auth.FacebookAuthProvider()
            break
          default:
            provider = null
          //erro de provedor
        }
        //const provider = new firebase.auth.GoogleAuthProvider();
        if (provider) {
          firebase
            .auth()
            .signInWithPopup(provider)
            .then(result => {
              resolve(result)
            })
            .catch(err => {
              reject(err)
            })
        } else
          reject({
            code: 'noPrivider',
            message: 'Erro de provedor do firebase.'
          })
      })
    },
    checkUserStatus({ commit }) {
      return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(user => {
          if (user) {
            commit('setFirebaseUser', user)
            resolve(user)
          } else {
            commit('setFirebaseUser', null)
            reject('User is not logged in.')
          }
        })
      })
    },
    async retrieveToken({ commit, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          let fireBaseUser = await dispatch('checkUserStatus')
          let token = await fireBaseUser.getIdToken(true)
          resolve(token)
        } catch (err) {
          reject(err)
        }
      })
    },
    reauthenticate({ commit, dispatch, getters }, payload) {
      return new Promise((resolve, reject) => {
        dispatch('checkUserStatus').then(user => {
          console.log('Reauthenticate params:', payload)
          let credential = getters.getFirebaseCredential
          if (!credential && payload) {
            credential = firebase.auth.EmailAuthProvider.credential(
              getters.getUserLogin, // references the user's email address
              payload
            )
          }
          if (credential) {
            user
              .reauthenticateWithCredential(credential)
              .then(user => {
                console.log('Reauthenticate result:', user)
                commit('setFirebaseUser', user)
                resolve(user)
              })
              .catch(err => {
                switch (err.code) {
                  case 'auth/user-mismatch':
                  case 'auth/user-not-found':
                  case 'auth/invalid-credential':
                  case 'auth/invalid-email':
                  case 'auth/wrong-password':
                  case 'auth/invalid-verification-code':
                  case 'auth/invalid-verification-id':
                  default:
                    reject(err)
                }
              })
          } else
            reject({
              code: 'auth/invalid-credential',
              message: 'Credencial Inválida. Por favor logue-se novamente.'
            })
        })
      })
    },
    login({ commit }, authData) {
      return new Promise((resolve, reject) => {
        //mocking AXIOS, to-do = connect API
        // console.log("authdata", authData);
        if (
          authData.email === 'admin@instacares.com.br' &&
          authData.senha === '1nst@car3s'
        ) {
          commit('authAdmin', {
            email: authData.email,
            token: 'mockedToken',
            id: '-1',
            nome: 'Administrador Instacares',
            exp: '-1'
          })
          resolve()
        } else {
          commit('clearAdminData')
          reject()
        }
        /*
        this.state.loading = true;
        var config = {
          headers: {
            "Access-Control-Allow-Origin": "*"
          }
        };
        
        
        axios
          .post(
            process.env.VUE_APP_ITS_CONTROLLER + "login/adminLogin.php",
            {
              params: authData
            },
            config
          )
          .then(response => {
            // console.log("dentro do promise");
            commit("Logged");
            this.state.loading = false;
            let result = response.data;
            // console.log(result);
            if (result === "error") {
              commit("notFailed");
            }
            commit("authAdmin", {
              email: result.login,
              token: result.token,
              id: result.id,
              nome: result.nome,
              exp: result.exp
            });
            dispatch("setAdminTimer", result.exp);
            router.replace("/admin/");
            resolve()
          })
          .catch(function(error) {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
            reject();
          });
          */
      })
    },
    async logout({ commit }, params) {
      commit('resetState')
      try {
        await firebase.auth().signOut()
      } catch (error) {
        console.log(error)
      }
      if (params.redirect) router.replace('/')
    }
  },
  modules: {}
})
